
var $ = require('jquery')
var jQueryBridget = require("jquery-bridget");
var Flickity = require("flickity");
var asNavFor = require("flickity-as-nav-for");
var matchHeight = require("jquery-match-height");
import { ScrollTrigger } from "gsap/ScrollTrigger";

Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, $);

var carousels = [];

Flickity.createMethods.push('_createPrevNextCells');

Flickity.prototype._createPrevNextCells = function() {
  this.on( 'select', this.setPrevNextCells );
};

Flickity.prototype.setPrevNextCells = function() {
  // remove classes
  changeSlideClasses( this.previousSlide, 'remove', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'remove', 'is-next' );
  // set slides
  this.previousSlide = this.slides[ this.selectedIndex - 1 ];
  this.nextSlide = this.slides[ this.selectedIndex + 1 ];
  // add classes
  changeSlideClasses( this.previousSlide, 'add', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'add', 'is-next' );
};

function changeSlideClasses( slide, method, className ) {
  if ( !slide ) {
    return;
  }
  slide.getCellElements().forEach( function( cellElem ) {
    cellElem.classList[ method ]( className );
  });
}

var carouselsCards = $(".carousel-cards .carousel");
carouselsCards.each(function(index, el) {
	let cardsCarousel = $(this);

	cardsCarousel.on(' ready.flickity', function(e, index) {
		$(this).find('.carousel-cards__card').matchHeight();
		cardsCarousel.removeClass('init-height');
		// let flkty = Flickity.data($(this)[0]);
		// console.log(flkty);
		// if ( flkty !== undefined ) {
		// 	cardsCarousel.flickity('resize');
		// }
	})

	$(window).on('load', function(){

		cardsCarousel.flickity({
			cellAlign: 'left',
			contain: true,
			watchCSS: true,
		})


		cardsCarousel.flickity('resize');

		if ( !cardsCarousel.hasClass('carousel-mobile-only') ) {
			cardsCarousel.flickity('resize'); 
			// cardsCarousel.flickity('reposition'); 
		}

		ScrollTrigger.refresh();
	})
	
	$(window).on('resize', function() {

		if ( window.matchMedia( "(min-width: 768px)" ).matches ) {
			cardsCarousel.find('.carousel-cards__card').matchHeight({remove: true});
		} 

	})
    carousels.push(cardsCarousel);
})

var carouselsMedia = $(".carousel-media .carousel");
carouselsMedia.each(function(index, el) {
	let mediaCarousel = $(this)

	mediaCarousel.on('ready.flickity', function() {
		mediaCarousel.removeClass('init-height');
	})

    mediaCarousel = $(el).flickity({
        cellAlign: 'left',
        wrapAround: true,
        pageDots: false,
    } )

    carousels.push(mediaCarousel);
})

var mediaAndBlocks = $('.media-and-blocks .carousel');
mediaAndBlocks.each(function() {
	var mediaAndBlocksCarousel = $(this);

	mediaAndBlocksCarousel.on( 'ready.flickity', function() {
		mediaAndBlocks.removeClass('init-height');
		if ( $(window).width() <= 768 ) {
			mediaAndBlocks.find('.media-and-blocks__content').matchHeight();
		}
	})

	mediaAndBlocksCarousel = $(this).flickity({
		prevNextButtons: false,
		contain: true,
		watchCSS: true,
		cellAlign: "left",
	})

	mediaAndBlocksCarousel.flickity('resize');

	carousels.push(mediaAndBlocksCarousel);
})

// for mobile only
var tabsAndContent = $(".tabs-and-content");
tabsAndContent.each(function() {
	var _this = $(this);
	var nav = _this.find('.tabs-and-content__tabs');
	var content = _this.find('.tabs-and-content__contents');
	
	$(window).on('load', function() {
		content.flickity({
			pageDots: false,
			prevNextButtons: false,
			draggable: false,
			watchCSS: true,
		})

		if ( $(window).width() <= 768 ) {
			setTimeout(function() {
				nav.flickity({
					asNavFor: content[0],
					pageDots: false,
					prevNextButtons: false,
					cellAlign: 'left',
					watchCSS: true,
				})
			}, 500);
		} 


		nav.on('change.flickity', function(event, index) {
			content.flickity('selectCell', index, false, false);
		})
	})


	carousels.push(nav, content);
})

global.carousels = carousels;